import {createAction} from 'redux-actions';

import {SET_DEFAULT_VIEW, SET_CURRENT_PATH} from './types';

export const setDefaultView = createAction(SET_DEFAULT_VIEW);
export const setCurrentPath = createAction(SET_CURRENT_PATH);
